import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { getCurrentTimezoneOffset } from 'utils/get-timezone-offset';

import { ISPFieldType } from '../../model';
import { ISPFieldTypeBase } from '../field-type-base.class';

/**
 * Hidden field component for Formly
 */
@Component({
  selector: 'isp-formly-hidden',
  templateUrl: './hidden.component.html',
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HiddenFieldComponent
  extends ISPFieldTypeBase<ISPFieldType.Hidden>
  implements OnInit
{
  ngOnInit(): void {
    super.ngOnInit();

    // @WARN This is legacy feature from Orion.
    // we need set value hidden input with name tzoffset to send on BE user timezone offset on registration
    // BE script set value direclty on native element so angular cant update input value
    // so we use setValue
    if (this.field.key === 'tzoffset') {
      const timezoneOffset = getCurrentTimezoneOffset();
      this.formControl.setValue(timezoneOffset);
    }
  }
}
